// The legacy build is the ES5 one webpack 4 can consume; the worker is copied
// next to the app by the CopyWebpackPlugin entry in vue.config.js.
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.BASE_URL}pdf.worker.js`;
export default pdfjsLib;
